import React from "react";
import { View, StyleSheet } from "react-native";
import NtSectionTitle from "../general/NtSectionTitle";
import NtSectionDescription from "../general/NtSectionDescription";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";

function NtTelehealthOutbreakSection({}) {
  return (
    <NtMarketingSectionContainer style={styles.container}>
      <View style={{ width: "100%" }}>
        <NtSectionTitle>
          STOP OUTBREAKS BEFORE{"\n"}THEY CAN SPREAD.
        </NtSectionTitle>
        <NtSectionDescription style={{ textAlign: "center", marginTop: 20 }}>
          Cruise lines have the new priority of providing reassurance that their
          cruise will be a healthy experience. Voxcraft’s new solution
          integrates innovative technologies that improve health monitoring and
          contact tracing onboard cruise ships. The system remotely gathers and
          provides the medical team with a wealth of critical information that
          is immediately actionable.
        </NtSectionDescription>
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingTop: 60,
    paddingBottom: 60,
    alignItems: "center",
  },
});

export default NtTelehealthOutbreakSection;
